import { DataGridPro } from "@mui/x-data-grid-pro";
import CustomLoadingOverlay from "../../common/data-grid/customLoadingOverlay";
import React, { useMemo } from "react";

const IbDataGrid = ({
  getRowId,
  loading,
  rows,
  columns,
  editMode,
  rowModesModel,
  cellModesModel,
  onRowModesModelChange,
  processRowUpdate,
  initialState,
}) => {
  const sxStyles = useMemo(() => ({
    "& .MuiDataGrid-columnHeaders": {
      boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fff",
    },
    "& .MuiDataGrid-cell": {
      backgroundColor: "#fff",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#fff",
      boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    },
    "& .MuiDataGrid-filler": {
      backgroundColor: "#fff",
    },
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    marginTop: "10px",
    padding: "4px",
    backgroundColor: "#fff",
  }), []);

  return (
    <DataGridPro
      autoWidth
      getRowId={getRowId}
      loading={loading}
      rows={rows}
      columns={columns}
      editMode={editMode}
      rowModesModel={rowModesModel}
      cellModesModel={cellModesModel}
      onRowModesModelChange={onRowModesModelChange}
      processRowUpdate={processRowUpdate}
      initialState={initialState}
      disableRowSelectionOnClick
      slots={{
        loadingOverlay: CustomLoadingOverlay,
      }}
      sx={sxStyles}
    />
  );
};

export default IbDataGrid;